// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"577":"dcec061d","728":"95da0287","897":"9b6074f2","928":"32138526"}[chunkId] + ".chunk.css";
};